import Header from './components/Header';
import HallDetailsPage from './pages/HallDetailsPage';
import MainPage from './pages/MainPage';
import RulesPage from './pages/RulesPage';
import './styles/css/main.css'
import {Routes, Route} from 'react-router-dom'

function App() {
    return (
        <div className="container">
            <Header />
            <Routes>
                <Route path='/' element={<MainPage />}/>
                <Route path='/hall/:id' element={<HallDetailsPage />}/>
                <Route path='/rules' element={<RulesPage />}/>
            </Routes>
        </div>
    );
}

export default App;
